import * as React from 'react'
import {observer} from 'mobx-react'
import {PaymentMethod} from '@raisenow/epik'
import {useStores} from '../../../../lib/MobXProvider'
import {WidgetApi} from '../../../../lib/WidgetApi'
import {IconDownload} from '../../../ui/Icons'

///////////////////////////////////////////////////////////////////////////////

export const PaymentDownloadPdf = observer(() => {
  const {api} = useStores<{api: WidgetApi}>()
  const transactionInfo = api.transactionInfo

  if (!transactionInfo) {
    return null
  }

  const paymentMethod = transactionInfo.payment_method
  const isEs = paymentMethod === PaymentMethod.PAYMENT_SLIP
  const isEzs =
    paymentMethod === PaymentMethod.PAYMENT_SLIP_WITH_REFERENCE_NUMBER
  const isDd = paymentMethod === PaymentMethod.DIRECT_DEBIT

  const isEsPdf = isEs && transactionInfo.stored_es_ordered === false
  const isEzsPdf = isEzs && transactionInfo.stored_ezs_ordered === false
  const isDdPdf = isDd && !!transactionInfo.pdflink

  let downloadUrl = null

  downloadUrl = isEsPdf ? transactionInfo.espayment_pdflink : downloadUrl
  downloadUrl = isEzsPdf ? transactionInfo.ezspayment_pdflink : downloadUrl
  downloadUrl = isDdPdf ? transactionInfo.pdflink : downloadUrl

  const subtitle = api.trans(`blocks.payment_status.pdf_download.subtitle`, {
    defaultValue: null,
  })
  const buttonText = api.trans(`blocks.payment_status.pdf_download.download`, {
    defaultValue: null,
  })

  if (!downloadUrl || !subtitle || !buttonText) {
    return null
  }

  const download = () => window.open(downloadUrl, '_blank')

  return (
    <div className="payment-download-pdf">
      <div className="header">{subtitle}</div>
      <div className="main">
        <button
          type="button"
          className="btn btn-block btn-primary"
          onClick={download}
        >
          <IconDownload />
          <span className="btn-text">{buttonText}</span>
        </button>
      </div>
    </div>
  )
})
